import { render, staticRenderFns } from "./AdditionalInformationTab.vue?vue&type=template&id=01db73a8&scoped=true&"
import script from "./AdditionalInformationTab.vue?vue&type=script&lang=js&"
export * from "./AdditionalInformationTab.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInformationTab.vue?vue&type=style&index=0&id=01db73a8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01db73a8",
  null
  
)

export default component.exports